import { Link, usePage } from '@inertiajs/react'
import { t, type TranslationKey } from '@/shared/lib/i18n'
import { newSessionPath } from '@/shared/lib/routes'
import { AuthShell } from '../Auth/AuthShell'

type SsoErrorReason = 'tenant_not_found' | 'not_configured' | 'auth_failed'

interface SsoErrorProps {
  reason?: SsoErrorReason
  [key: string]: unknown
}

const REASON_DESCRIPTION_KEYS: Record<SsoErrorReason, TranslationKey> = {
  tenant_not_found: 'sso.error.reasons.tenantNotFound',
  not_configured: 'sso.error.reasons.notConfigured',
  auth_failed: 'sso.error.reasons.authFailed',
}

const SsoError = () => {
  const { reason } = usePage<SsoErrorProps>().props
  const descriptionKey: TranslationKey =
    reason && reason in REASON_DESCRIPTION_KEYS
      ? REASON_DESCRIPTION_KEYS[reason]
      : 'sso.error.description'

  return (
    <AuthShell pageTitle={t('sso.error.title')}>
      <h1 className="text-2xl font-bold">{t('sso.error.heading')}</h1>

      <p className="text-sm text-muted-foreground">{t(descriptionKey)}</p>

      <div className="text-center">
        <Link
          href={newSessionPath()}
          className="text-sm text-muted-foreground underline-offset-4 hover:underline"
        >
          {t('sso.error.backToLogin')}
        </Link>
      </div>
    </AuthShell>
  )
}

export default SsoError
